export const GET_GUIDETEMPLATES = 'GET_GUIDETEMPLATES';
export const SET_GUIDETEMPLATES = 'SET_GUIDETEMPLATES';
